import Head from 'next/head';
import React from 'react';

/** Loads landing fonts only for landing/policies — not the rest of the dashboard. */
export const LandingFonts: React.FC = () => {
  return (
    <Head>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=Syne:wght@600;700;800&display=swap"
        rel="stylesheet"
      />
    </Head>
  );
};

export const LandingShell: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => {
  return (
    <>
      <LandingFonts />
      <div className={className ? `landing-shell ${className}` : 'landing-shell'}>{children}</div>
    </>
  );
};
